import "bootstrap";
import "./modules/plyr";
import "./modules/tooltip";
import "./modules/countdown"
import "./modules/headroom";
import "./modules/tiny-slider";
import "./modules/prism";
import "./modules/aos";

import "./modules/navbar";
import "./modules/parallax";
import "./modules/big-picture";

import "./modules/isotope";
import "./modules/offcanvas";
import "./modules/forms";
import "./modules/nouislider";
import "./modules/counter";
import "./modules/typed";
import "./modules/smooth-scroll";
import "./modules/obfuscation";

import lightGallery from "lightgallery";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";

window.axios = require('axios');

[].forEach.call(document.getElementsByClassName('animated-thumbnails-gallery'), gallery => {

    lightGallery(gallery, {
        plugins: [lgZoom, lgThumbnail],
        thumbnail: true,
        allowMediaOverlap: true,
        toggleThumb: true,
        speed: 500,
        licenseKey: '0000-0000-000-0000'
    });

})

//import intlTelInput from 'intl-tel-input';

window.intlTelInput = require('intl-tel-input')


